
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Cell from 'vux/src/components/cell/index.vue'

import WxHeader from './Header'

export default {
data(){
return{
ishow:false,
type_list : [],
post:{
member_phone : '',
member_name : '',
member_address : '',
content:'',
type_ids : ''
}
}
},
components: {
XTextarea,
Group,
XInput,
XButton,
WxHeader,
Alert,
AlertModule,
Cell
},
created() {
this.init();
this.getTypeList();
},
methods: {
onEvent (event) {
console.log('on', event)
},
init(){
let login_data = this.get_login_session_data();
console.log('login_data');
console.log(login_data);
if(!!login_data){

this.post.member_address = login_data.house_addr;
this.post.member_phone = login_data.member_phone;
}
},
getTypeList(){
let _self = this;
let api_url = this.server_api_url+'service=get_complain_type_list';
this.$axios({
method:'post',
url:api_url
}).then((response) =>{
let data_arr = response.data;
if(data_arr.status == '1'){
_self.type_list = data_arr.data.list;
}
}).catch((response) =>{
console.log(response)
})
},
getChecked: function() {


return this.type_list.filter(item => item.checked).map(item => item.id)
},
submit(){
let _self = this;

let api_url = this.server_api_url+'service=save_complain_content';
var formData = _self.post;
let login_data = this.get_login_session_data();
/*let login_data = {};
login_data.openid = 'oHEzntyApZZIJewheTeYo23CM0zY';
login_data.member_id = 1;*/
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
}else{
return false;
}

let type_ids = this.getChecked();

if(this.type_list.length > 0 && type_ids.length <= 0){
_self.baseShowModule('请选择投诉类型','提交失败');
return false;
}

if(this.post.member_name.length <= 1){
_self.baseShowModule('姓名至少2个字','提交失败');
return false;
}

if(this.post.member_phone.length != 11){
_self.baseShowModule('手机格式不对','提交失败');
return false;
}

if(this.post.member_address.length <= 1){
_self.baseShowModule('房号至少2个字','提交失败');
return false;
}

this.post.type_ids = type_ids.toString();

if(this.post.content.length <= 0){
_self.baseShowModule('内容未填写','提交失败');
return false;
}

formData = this.qs.stringify(formData);
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,

}).then((response) =>{
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(data_arr.status == '1'){
_self.baseShowModuleAuto(data_arr.msg,'提交成功',3000,'/ComplainMy');
}else{
_self.baseShowModule(data_arr.msg,'提交失败');
}
}).catch((response) =>{
console.log(response)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Complain.vue